// extracted by mini-css-extract-plugin
module.exports = {"Ribbon":"Ribbon_Ribbon__9ovZm","Text":"Ribbon_Text__ALAwP"};